import Component from './Component'
import withLocale from '@modules/translate/withLocale';

export default withLocale(Component)
